export const formatPriceGBP = (price = 0) =>
    price.toLocaleString("en-GB", { style: "currency", currency: "GBP" });

export const validateInputPrice = (val) => {
    const regex = /^[0-9]+(\.\d?\d)?$/;
    return regex.test(val);
};